export function downloadUrlParser(data: { path: any; filename: any; originalname: any; mimetype: any }){
    let path = "";
    path += "&path=" + data.path;
    path += "&filename=" + data.filename;
    path += "&originalname=" + data.originalname;
    path += "&mimetype=" + data.mimetype;
    return import.meta.env["VITE_APP_API"] + "/download-file?" + path;
}
